module.exports = __webpack_public_path__ + "img/tape-measure.f76bf18e.webp";